import { render, staticRenderFns } from "./mailing-list.vue?vue&type=template&id=1d40961e"
import script from "./mailing-list.vue?vue&type=script&lang=js"
export * from "./mailing-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports